import moment from 'moment';

export const CertificateType = {
  BASIC40: 'Basic 40 (includes S-130, S-190, L-180)',
  S130: 'S-130',
  S190: 'S-190',
  L180: 'L-180',
  FEMA_IS100: 'FEMA IS-100',
  FEMA_IS700: 'FEMA IS-700',
  RT130: 'RT-130',
  RESUME: 'Resume',
  FIRE_HISTORY: 'Fire History',
  FIRSTAID_CPR: 'First Aid/CPR',
  WCT: 'WCT',
};

const currentYear = moment().utcOffset('-08:00').year();

export const CertificateStatus = {
  NO_TRAINING: 'No Training',
  NEED_RT130: 'Need RT-130 - CERT NOT CURRENT',
  COMPLETED_BASIC_TRAINING: 'Completed Basic Training',
  COMPLETED_RT130: 'Completed RT-130',
};
